var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ListForm',{attrs:{"api":"coopBank","id":_vm.id,"labelPosition":"top","formTitle":"銀行帳戶管理","rules":_vm.rules,"recordToEdit":_vm.recordToEdit,"formType":_vm.formType}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }